import React from 'react';
import PropTypes from 'prop-types';
import {Form, Input as UInput} from '@rocketseat/unform';
import {Spinner, Button, Input} from 'reactstrap';
import I18nMessage from '../../components/I18nMessage';
import {useIntl} from 'react-intl';
import styled from 'styled-components';
import {useCompany} from '../../providers/company';
import {observer} from 'mobx-react';
import Image from 'src/components/image/image';
import classNames from 'classnames';

const LoginForm = (props) => {
    const {
        error,
        clear,
        schema,
        loading,
    } = props;

    const intl = useIntl();
    const {
        logoUrl,
        theme,
        androidAppUrl,
        iosAppUrl,
        hasLogoLoaded,
        hideLoginFooter,
    } = useCompany();

    const logoClass = classNames({
        'logo': !!logoUrl,
        'logo-placeholder': !!logoUrl === false,
    });
    const LoginButtonStyled = styled(Button)`
    color: #FFFFFF;
    background-color: ${(props) => props.theme} !important;
    border-color: ${(props) => props.theme};
    `;
    return (
        <div className="wrapper fadeInDown">
            <div id="formContent">

                <div className="logo-wrapper fadeIn first">
                    <Image
                        src={logoUrl}
                        alt="logo"
                        className={logoClass}
                        kind='rectangular'
                        skeletonProps={{
                            className: 'logo-placeholder',
                        }}
                    />
                </div>

                <Form schema={schema}
                      className="login100-form validate-form"
                      onSubmit={props.onLogin}
                >
                    <br/>
                    <div className={'form-item'}>
                        <Input
                            onChange={() => clear()}
                            className="form__input"
                            tag={UInput}
                            type="text"
                            name="email"
                            placeholder={intl.formatMessage({id: 'userEmail'})}
                            id="email"
                        />
                    </div>
                    <br/>
                    <div className={'form-item'}>
                        <Input
                            onChange={() => clear()}
                            className="form__input"
                            tag={UInput}
                            type="password"
                            name="password"
                            id="password"
                            placeholder={intl.formatMessage({id: 'userPassword'})}
                            autoComplete={'new-password'}
                        />
                    </div>

                    <div style={{padding: 20}}>
                        <LoginButtonStyled className="btn btn-primary btn-lg btn-block" theme={theme}>
                            {loading ? <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> :
                                <I18nMessage id="loginTitle"/>}
                        </LoginButtonStyled>
                    </div>

                    <div className="text-center p-t-46 p-b-20">
                        {error && <span className="txt-error">
                            <I18nMessage id="errorAuthorization"/>
                        </span>}
                    </div>

                    <div className={'row'}>
                        <div className={'col'}>
                            <a
                               href={iosAppUrl}>
                                <img
                                    className='mobile-badge'
                                    alt={intl.formatMessage({id: 'loginAppStoreAlt'})}
                                    src={`${process.env.PUBLIC_URL}/images/app-store-badge.svg`}
                                />
                            </a>
                        </div>
                        <div className={'col'}>
                            <a
                                href={androidAppUrl}>
                                <img
                                    className='mobile-badge'
                                    alt={intl.formatMessage({id: 'loginGooglePlayAlt'})}
                                    src={`${process.env.PUBLIC_URL}/images/google-play-badge.png`}
                                    style={{
                                        margin: '-3px 0',
                                    }}
                                />
                            </a>
                        </div>
                    </div>

                </Form>
            </div>

            {!hideLoginFooter && (
                <footer className='my-3'>
                    <p className='copyright'>© Azul Tecnologia - All rights reserved
                    <br/>{intl.formatMessage({id: 'loginVersion'})}</p>
                </footer>
            )}
        </div>
    );
};

LoginForm.propTypes = {
    onLogin: PropTypes.func.isRequired,
    error: PropTypes.bool,
    clear: PropTypes.func,
    schema: PropTypes.object,
    loading: PropTypes.bool,
};

export default observer(LoginForm);
